import script from "./PermissionCatalog.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionCatalog.vue?vue&type=script&setup=true&lang=js"

import "./PermissionCatalog.vue?vue&type=style&index=0&id=4e4800d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4800d3"]])

export default __exports__